import { HeartOutlined } from "@ant-design/icons";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
} from "@mui/material";
import { Select } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CREATE_jwel } from "../Config/Config";
import Header from "../Header";
import SidebarDrawer from "../SidebarDrawer";
import styles from "./Crm.module.css";

const { Option } = Select;

const sections = [
  "Today Birthdays",
  "Today Anniversaries",
  "Today Dues",
  "Total Dues",
];

const Crm = () => {
  const [expanded, setExpanded] = useState([]);
  const [open, setOpen] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [areaDropDownCustomer, setAreaDropDownCustomer] = useState([]);
  const [selectAreaCustomer, setSelectAreaCustomer] = useState("");
  const [customerData, setCustomerData] = useState([]);
  const [birthDayData, setBirthDayData] = useState([]);
  const [todayAnniversaryData, setTodayAnniversaryData] = useState([]);
  // const [imagesData, setImagesData] = useState([]);
  // const [userArea, setUserArea] = useState();
  // const [userName, setUserName] = useState();
  // const [singleImage, setSingleImage] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalDues, setTotalDues] = useState(0);

  const imageUrls = localStorage.getItem("images").split(",");
  const imagesData = imageUrls;
  const userArea = localStorage.getItem("city");
  const userName = localStorage.getItem("user");
  const singleImage = localStorage.getItem("singleImage");
  const tenantName = localStorage.getItem("tenantName");

  const toggleDrawer = () => {
    setOpen(false);
  };

  const customerAreaDropDownAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetOutStandingCustForCity`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setAreaDropDownCustomer(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const customerAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetOutstandingCustemerData?area=${
          selectAreaCustomer ? selectAreaCustomer : "%"
        }`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setCustomerData(data);
        const totalPay = data.reduce((acc, item) => {
          const jama = Number(item.PAYAMT) || 0;
          return acc + jama;
        }, 0);
        setTotalDues(totalPay);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const todayBirthdayAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=DOB='${dayjs().format(
          "MM/DD/YYYY"
        )}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setBirthDayData(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };
  const todayAnniversaryAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=ANNVERSARY='${dayjs().format(
          "MM/DD/YYYY"
        )}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setTodayAnniversaryData(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  // const userAPI = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
  //       {
  //         headers: {
  //           tenantName: tenantName,
  //         },
  //       }
  //     );

  //     const data = response.data;

  //     if (Array.isArray(data) && data.length > 0) {
  //       const imageUrls = data[0]?.EPASS1.split(",");
  //       setImagesData(imageUrls);
  //       setUserName(data[0]?.FIRMNAME);
  //       setUserArea(data[0]?.CITY);
  //       setSingleImage(data[0]?.EPASS2);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching estimation count:", error);
  //   }
  // };

  useEffect(() => {
    customerAreaDropDownAPI();
    customerAPI();
    todayBirthdayAPI();
    todayAnniversaryAPI();
    // userAPI();
  }, [selectAreaCustomer]);

  const handleExpandAll = () => {
    setExpanded("all");
    customerAreaDropDownAPI();
    customerAPI();
    todayBirthdayAPI();
    todayAnniversaryAPI();
  };

  const handleCollapseAll = () => {
    setExpanded(null);
  };

  const handleChange = (panel) => {
    setExpanded((prev) => (prev === panel ? null : panel));
  };

  useEffect(() => {
    if (imagesData.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % imagesData.length);
      }, 1500);
      return () => clearInterval(interval);
    }
  }, [imagesData]);

  return (
    <div>
      <Header setOpen={setOpen} />
      <SidebarDrawer
        open={open}
        toggleDrawer={toggleDrawer}
        singleImage={singleImage}
        userArea={userArea}
        userName={userName}
      />
      <div className={styles.carouselContainer}>
        <div
          className={styles.carouselSlider}
          style={{
            transform: `translateX(-${currentIndex * 33.33}%)`,
            width: `${imagesData.length * 100}%`,
          }}
        >
          {imagesData.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`img-${index}`}
              className={styles.carouselImage}
            />
          ))}
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <h3 className={styles.heading}>CRM</h3>
          <div className={styles.buttonRow}>
            <button
              variant="outlined"
              type="default"
              className={styles.expandButton}
              onClick={handleExpandAll}
            >
              Expand All +
            </button>
            <button
              variant="outlined"
              type="default"
              className={styles.collapseButton}
              onClick={handleCollapseAll}
            >
              Collapse All -
            </button>
          </div>
        </div>
        {/* <div className={styles.dateFilters}>
          <DatePicker
            value={fromDate}
            onChange={setFromDate}
            className={styles.datePicker}
            inputReadOnly
            format="DD-MMM-YYYY"
          />
          <DatePicker
            value={toDate}
            onChange={setToDate}
            className={styles.datePicker}
            inputReadOnly
            format="DD-MMM-YYYY"
          />
        </div> */}
        <div style={{ marginBottom: "5px", marginTop: "10px" }}>
          <Accordion
            expanded={expanded === "panel1" || expanded === "all"}
            onChange={() => {
              handleChange("panel1");
              todayBirthdayAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel1" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel1" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Today Birthdays
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                  fontSize: "12px",
                  marginLeft: "50px",
                }}
              >
                <Badge badgeContent={birthDayData.length} color="warning">
                  <CakeOutlinedIcon
                    className={`${styles.occasionIcon} ${styles.birthdayIcon}`}
                  />
                </Badge>
              </div>
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel1" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel1" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {birthDayData.map((birth, index) => (
                <div
                  key={birth.id}
                  style={{
                    marginBottom: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "1px",
                      backgroundColor: "#000",
                      marginRight: "10px",
                    }}
                  />
                  <div
                    style={{
                      border: "1px solid #000",
                      borderRadius: "4px",
                      padding: "10px 20px",
                      fontFamily: "monospace",
                      fontSize: "14px",
                      textAlign: "center",
                      backgroundColor: "#fff59d",
                      // background:
                      //   "radial-gradient(circle at center, #fff59d 40%, #ffe082 60%, #ffcc80 80%)",
                      boxShadow: "2px 2px 0px #000",
                    }}
                  >
                    <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                      {birth.Custname}
                    </div>
                    <div style={{ fontStyle: "italic", marginBottom: "5px" }}>
                      {birth.Area}
                    </div>
                    <div style={{ marginBottom: "5px" }}>{birth.Mobileno}</div>
                    <div style={{ fontWeight: "bold", color: "#1a237e" }}>
                      {dayjs(birth.dob).format("DD-MMM-YYYY")}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "50px",
                      height: "1px",
                      backgroundColor: "#000",
                      marginLeft: "10px",
                    }}
                  />
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel2" || expanded === "all"}
            onChange={() => {
              handleChange("panel2");
              todayAnniversaryAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel2" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel2" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Today Anniversaries
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                  fontSize: "12px",
                  marginLeft: "50px",
                }}
              >
                <Badge
                  badgeContent={todayAnniversaryData.length}
                  color="success"
                >
                  <HeartOutlined
                    className={`${styles.occasionIcon} ${styles.anniversaryIcon}`}
                  />
                </Badge>
              </div>
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel2" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel2" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {todayAnniversaryData.map((anniversary, index) => (
                <div
                  key={anniversary.id}
                  style={{
                    marginBottom: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* Left line */}
                  <div
                    style={{
                      width: "50px",
                      height: "1px",
                      backgroundColor: "#000",
                      marginRight: "10px",
                    }}
                  />

                  {/* Center box with data */}
                  <div
                    style={{
                      border: "1px solid #000",
                      borderRadius: "4px",
                      padding: "10px 20px",
                      fontFamily: "monospace",
                      fontSize: "14px",
                      textAlign: "center",
                      backgroundColor: "#ef9a9a",
                      // background:
                      //   "radial-gradient(circle at center, #ef9a9a 40%, #f48fb1 60%, #ce93d8 80%)",
                      boxShadow: "2px 2px 0px #000",
                    }}
                  >
                    <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                      {anniversary.Custname}
                    </div>
                    <div style={{ fontStyle: "italic", marginBottom: "5px" }}>
                      {anniversary.Area}
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      {anniversary.Mobileno}
                    </div>
                    <div style={{ fontWeight: "bold", color: "#1a237e" }}>
                      {dayjs(anniversary.ANNVERSARY).format("DD-MMM-YYYY")}
                    </div>
                  </div>

                  {/* Right line */}
                  <div
                    style={{
                      width: "50px",
                      height: "1px",
                      backgroundColor: "#000",
                      marginLeft: "10px",
                    }}
                  />
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel3" || expanded === "all"}
            onChange={() => {
              handleChange("panel3");
              customerAreaDropDownAPI();
              customerAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                backgroundColor:
                  expanded === "panel3" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel3" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Total Dues
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                  fontSize: "12px",
                  marginLeft: "50px",
                  // background: "#fff",
                  backgroundColor:
                    expanded === "panel3" || expanded === "all"
                      ? "white"
                      : "#52bd91",
                  color:
                    expanded === "panel3" || expanded === "all"
                      ? "#52bd91"
                      : "black",
                  padding: "8px 10px 5px 10px",
                  borderRadius: "8px",
                }}
              >
                {/* Pending Dues:{" "} */}
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color:
                      expanded === "panel3" || expanded === "all"
                        ? "white"
                        : "red",
                    color:
                      expanded === "panel3" || expanded === "all"
                        ? "red"
                        : "black",
                  }}
                >
                  {"₹" + totalDues?.toFixed(2)}
                </span>
              </div>
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel3" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel3" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <div style={{ width: "100px", fontWeight: "bold" }}>
                  Select Area:
                </div>
                <Select
                  allowClear
                  showSearch={false}
                  placeholder="Select Area"
                  style={{ width: "70%" }}
                  value={selectAreaCustomer || undefined}
                  onChange={(value) => {
                    setSelectAreaCustomer(value); // value will be `undefined` when cleared
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const filteredOptions = areaDropDownCustomer.filter(
                        (area) =>
                          area.AREA.toLowerCase().includes(
                            e.target.value.toLowerCase()
                          )
                      );
                      if (filteredOptions.length > 0) {
                        setSelectAreaCustomer(filteredOptions[0].AREA);
                      }
                    }
                  }}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {areaDropDownCustomer.map((area, index) => (
                    <Option key={index} value={area.AREA}>
                      {area.AREA}
                    </Option>
                  ))}
                </Select>
              </div>
              {customerData.map((customer, index) => (
                <div
                  key={customer.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      City:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {customer.AREA}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Customer Name:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {customer.PARTYNAME}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {customer.PAYAMT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default Crm;
